import { useTranslation } from "react-i18next";
import styles from "./Spinner.module.css";

export function Spinner({ label }: { label?: string }) {
  const { t } = useTranslation();
  return <div className={styles.wrap} role="status"><span className={styles.flame} aria-hidden /><span className="visually-hidden">{label ?? t("loading")}</span></div>;
}
